import { z } from "zod";
import { capitalize } from "../../strings";
import { ZodPassword } from "../zod-types/zod-password";

export const emailPasswordSchema = z.object({ email: z.email(), password: ZodPassword });

export const confirmPasswordSchema = z.object({
	password: ZodPassword,
	confirmPassword: z.string(),
});

export const userSignUpSchema = z
	.object({
		firstName: z.string().min(1, "First name is required").transform(capitalize),
		lastName: z.string().min(1, "Last name is required").transform(capitalize),
		name: z.string().optional(),
	})
	.and(emailPasswordSchema)
	.and(confirmPasswordSchema)
	.superRefine((data, context) => {
		if (data.password !== data.confirmPassword) {
			context.addIssue({
				code: "custom",
				message: "Passwords do not match",
				path: ["confirmPassword"],
			});
		}
	});

export type UserSignUpSchema = z.infer<typeof userSignUpSchema>;
export type ConfirmPasswordSchema = z.infer<typeof confirmPasswordSchema>;
export type EmailPasswordSchema = z.infer<typeof emailPasswordSchema>;
